<template>
	<v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<!-- Date Filter -->
		<v-col cols="12" class="pa-0 pb-4">
			<v-card class="background-2 round-card elevation-1">
				<v-card-title class="pa-3">
					<v-icon left>mdi-filter</v-icon>
					<p class="pl-2">Filtro Periodo</p>
					<v-spacer></v-spacer>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								color="primary"
								@click="loadStatistics"
								:loading="loading"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon>mdi-refresh</v-icon>
							</v-btn>
						</template>
						<span>Aggiorna</span>
					</v-tooltip>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<v-row class="ma-0">
						<v-col cols="12">
							<v-btn-toggle v-model="quickPeriod" dense class="ml-8">
								<v-btn small @click="setQuickPeriod('today')">Oggi</v-btn>
								<v-btn small @click="setQuickPeriod('week')">Settimana</v-btn>
								<v-btn small @click="setQuickPeriod('month')">Mese</v-btn>
								<v-btn small @click="setQuickPeriod('year')">Anno</v-btn>
							</v-btn-toggle>
						</v-col>
					</v-row>
					<v-row class="ma-0">
						<v-col cols="12" sm="4" md="3">
							<gmh-date-picker
								v-model="startDate"
								label="Data Inizio"
								prepend-icon="mdi-calendar"
								:append-icon="null"
								:clearable="false"
							></gmh-date-picker>
						</v-col>
						<v-col cols="12" sm="4" md="3">
							<gmh-date-picker
								v-model="endDate"
								label="Data Fine"
								prepend-icon="mdi-calendar"
								:append-icon="null"
								:clearable="false"
							></gmh-date-picker>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>

		<!-- Statistics Cards -->
		<v-col cols="12" sm="6" lg="3" :class="setClass(0)">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left color="primary">mdi-send</v-icon>
						<p class="pl-2">Inviati</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="text-center pa-4">
						<div class="text-h2 font-weight-bold primary--text">
							{{ statistics.total_sent || 0 }}
						</div>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>

		<v-col cols="12" sm="6" lg="3" :class="setClass(1)">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left color="success">mdi-check-all</v-icon>
						<p class="pl-2">Consegnati</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="text-center pa-4">
						<div class="text-h2 font-weight-bold success--text">
							{{ statistics.total_delivered || 0 }}
						</div>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>

		<v-col cols="12" sm="6" lg="3" :class="setClass(2)">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left color="info">mdi-eye</v-icon>
						<p class="pl-2">Letti</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="text-center pa-4">
						<div class="text-h2 font-weight-bold info--text">
							{{ statistics.total_read || 0 }}
						</div>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>

		<v-col cols="12" sm="6" lg="3" :class="setClass(3)">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left color="error">mdi-alert-circle</v-icon>
						<p class="pl-2">Falliti</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="text-center pa-4">
						<div class="text-h2 font-weight-bold error--text">
							{{ statistics.total_failed || 0 }}
						</div>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>

		<!-- Inbound Card -->
		<v-col cols="12" sm="6" lg="3" class="pa-0 pt-4">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left color="teal">mdi-message-arrow-left</v-icon>
						<p class="pl-2">Ricevuti</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="text-center pa-4">
						<div class="text-h2 font-weight-bold teal--text">
							{{ statistics.total_received || 0 }}
						</div>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>

		<!-- Performance Rates -->
		<v-col cols="12" class="pa-0 pt-4">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left>mdi-chart-arc</v-icon>
						<p class="pl-2">Tassi di Performance</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-row>
							<v-col cols="12" md="6" class="text-center">
								<div class="text-subtitle-1 mb-3">Tasso di Consegna</div>
								<v-progress-circular
									:rotate="360"
									:size="120"
									:width="15"
									:value="statistics.delivery_rate || 0"
									:color="getRateColor(statistics.delivery_rate)"
								>
									<span class="text-h5">{{ statistics.delivery_rate || 0 }}%</span>
								</v-progress-circular>
								<div class="text-caption mt-2">
									{{ statistics.total_delivered || 0 }} / {{ statistics.total_sent || 0 }} messaggi
								</div>
							</v-col>
							<v-col cols="12" md="6" class="text-center">
								<div class="text-subtitle-1 mb-3">Tasso di Lettura</div>
								<v-progress-circular
									:rotate="360"
									:size="120"
									:width="15"
									:value="statistics.read_rate || 0"
									:color="getRateColor(statistics.read_rate)"
								>
									<span class="text-h5">{{ statistics.read_rate || 0 }}%</span>
								</v-progress-circular>
								<div class="text-caption mt-2">
									{{ statistics.total_read || 0 }} / {{ statistics.total_delivered || 0 }} messaggi
								</div>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>

		<!-- Conversations Statistics -->
		<v-col cols="12" class="pa-0 pt-4">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left>mdi-message-text-outline</v-icon>
						<p class="pl-2">Conversazioni</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-row>
							<v-col cols="12" sm="6">
								<v-card outlined class="text-center pa-4">
									<v-icon x-large color="success">mdi-chat-processing</v-icon>
									<div class="text-h4 mt-2">{{ statistics.active_conversations || 0 }}</div>
									<div class="text-subtitle-1">Conversazioni Attive</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6">
								<v-card outlined class="text-center pa-4">
									<v-icon x-large color="primary">mdi-chat</v-icon>
									<div class="text-h4 mt-2">{{ statistics.total_conversations || 0 }}</div>
									<div class="text-subtitle-1">Conversazioni Totali</div>
								</v-card>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>

		<!-- Messages by Type Table -->
		<v-col cols="12" class="pa-0 pt-4">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left>mdi-format-list-bulleted-type</v-icon>
						<p class="pl-2">Messaggi per Tipo</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-0 pb-4">
						<v-simple-table>
							<thead>
								<tr>
									<th>Tipo Messaggio</th>
									<th class="text-right">Outbound</th>
									<th class="text-right">Inbound</th>
									<th class="text-right">Totale</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<v-chip small color="purple" dark class="mr-2">Marketing</v-chip>
									</td>
									<td class="text-right">{{ getByType('outbound', 'marketing') }}</td>
									<td class="text-right">{{ getByType('inbound', 'marketing') }}</td>
									<td class="text-right font-weight-bold">{{ getTotalByType('marketing') }}</td>
								</tr>
								<tr>
									<td>
										<v-chip small color="blue" dark class="mr-2">Transazionale</v-chip>
									</td>
									<td class="text-right">{{ getByType('outbound', 'transactional') }}</td>
									<td class="text-right">{{ getByType('inbound', 'transactional') }}</td>
									<td class="text-right font-weight-bold">{{ getTotalByType('transactional') }}</td>
								</tr>
								<tr>
									<td>
										<v-chip small color="orange" dark class="mr-2">OTP</v-chip>
									</td>
									<td class="text-right">{{ getByType('outbound', 'otp') }}</td>
									<td class="text-right">{{ getByType('inbound', 'otp') }}</td>
									<td class="text-right font-weight-bold">{{ getTotalByType('otp') }}</td>
								</tr>
								<tr>
									<td>
										<v-chip small color="grey" dark class="mr-2">Messaggi Liberi</v-chip>
									</td>
									<td class="text-right">{{ getByType('outbound', 'free_message') }}</td>
									<td class="text-right">{{ getByType('inbound', 'free_message') }}</td>
									<td class="text-right font-weight-bold">{{ getTotalByType('free_message') }}</td>
								</tr>
								<tr class="grey lighten-4">
									<td class="font-weight-bold">TOTALE</td>
									<td class="text-right font-weight-bold">{{ getOutboundTotal() }}</td>
									<td class="text-right font-weight-bold">{{ getInboundTotal() }}</td>
									<td class="text-right font-weight-bold primary--text text-h6">{{ statistics.total_billable || 0 }}</td>
								</tr>
							</tbody>
						</v-simple-table>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>

		<!-- Template Statistics -->
		<v-col cols="12" class="pa-0 pt-4">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left>mdi-file-document-outline</v-icon>
						<p class="pl-2">Statistiche Template</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-row>
							<!-- Total Template Messages -->
							<v-col cols="12" md="4" class="text-center">
								<v-card outlined class="pa-4" style="height: 100%;">
									<v-icon x-large color="deep-purple">mdi-file-send</v-icon>
									<div class="text-h4 mt-2 deep-purple--text">{{ statistics.template_messages || 0 }}</div>
									<div class="text-subtitle-1">Messaggi con Template</div>
									<div class="text-caption grey--text mt-1">
										{{ templatePercentage }}% del totale dei messaggi consegnati
									</div>
								</v-card>
							</v-col>

							<!-- By Template Type -->
							<v-col cols="12" md="4">
								<v-card outlined class="pa-4" style="height: 100%;">
									<div class="text-subtitle-1 mb-3 text-center">
										<v-icon small class="mr-1">mdi-tag-multiple</v-icon>
										Per Tipo Template
									</div>
									<div v-if="hasTemplateTypeData">
										<div
											v-for="(count, type) in statistics.by_template_type"
											:key="type"
											class="d-flex align-center justify-space-between mb-2"
										>
											<v-chip
												small
												:color="templateTypeColors[type] || 'grey'"
												dark
												class="mr-2"
											>
												{{ templateTypeLabels[type] || type }}
											</v-chip>
											<span class="font-weight-bold">{{ count }}</span>
										</div>
									</div>
									<div v-else class="text-center grey--text">
										Nessun dato disponibile
									</div>
								</v-card>
							</v-col>

							<!-- By Language -->
							<v-col cols="12" md="4">
								<v-card outlined class="pa-4" style="height: 100%;">
									<div class="text-subtitle-1 mb-3 text-center">
										<v-icon small class="mr-1">mdi-translate</v-icon>
										Per Lingua
									</div>
									<div v-if="hasLanguageData">
										<div
											v-for="(count, lang) in statistics.by_language"
											:key="lang"
											class="d-flex align-center justify-space-between mb-2"
										>
											<v-chip
												small
												:color="languageColors[lang] || 'grey'"
												dark
												class="mr-2"
											>
												{{ languageLabels[lang] || lang }}
											</v-chip>
											<span class="font-weight-bold">{{ count }}</span>
										</div>
									</div>
									<div v-else class="text-center grey--text">
										Nessun dato disponibile
									</div>
								</v-card>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>

		<!-- Detailed Statistics Table -->
		<v-col cols="12" class="pa-0 pt-4">
			<v-hover v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
					<v-card-title class="pa-3">
						<v-icon left>mdi-table</v-icon>
						<p class="pl-2">Riepilogo Dettagliato</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-0 pb-4">
						<v-simple-table>
							<thead>
								<tr>
									<th>Metrica</th>
									<th class="text-right">Valore</th>
									<th class="text-right">Percentuale</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<v-icon small color="primary" class="mr-2">mdi-send</v-icon>
										Messaggi Inviati
									</td>
									<td class="text-right">{{ statistics.total_sent || 0 }}</td>
									<td class="text-right">100%</td>
								</tr>
								<tr>
									<td>
										<v-icon small color="success" class="mr-2">mdi-check-all</v-icon>
										Messaggi Consegnati
									</td>
									<td class="text-right">{{ statistics.total_delivered || 0 }}</td>
									<td class="text-right">
										<v-chip small :color="getRateColor(statistics.delivery_rate)" dark>
											{{ statistics.delivery_rate || 0 }}%
										</v-chip>
									</td>
								</tr>
								<tr>
									<td>
										<v-icon small color="info" class="mr-2">mdi-eye</v-icon>
										Messaggi Letti
									</td>
									<td class="text-right">{{ statistics.total_read || 0 }}</td>
									<td class="text-right">
										<v-chip small :color="getRateColor(statistics.read_rate)" dark>
											{{ statistics.read_rate || 0 }}%
										</v-chip>
									</td>
								</tr>
								<tr>
									<td>
										<v-icon small color="error" class="mr-2">mdi-alert-circle</v-icon>
										Messaggi Falliti
									</td>
									<td class="text-right">{{ statistics.total_failed || 0 }}</td>
									<td class="text-right">
										<v-chip small :color="getFailRateColor(failRate)" dark>
											{{ failRate }}%
										</v-chip>
									</td>
								</tr>
								<tr>
									<td>
										<v-icon small color="teal" class="mr-2">mdi-message-arrow-left</v-icon>
										Messaggi Ricevuti
									</td>
									<td class="text-right">{{ statistics.total_received || 0 }}</td>
									<td class="text-right">-</td>
								</tr>
							</tbody>
						</v-simple-table>
					</v-card-text>
				</v-card>
			</v-hover>
		</v-col>
	</v-row>
</template>

<script>
import Vue from 'vue'
import { format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, startOfYear, endOfYear, startOfDay, endOfDay } from 'date-fns'

export default {
	name: 'WhatsAppStatisticsDashboard',

	data() {
		return {
			statistics: {
				total_sent: 0,
				total_delivered: 0,
				total_read: 0,
				total_failed: 0,
				total_received: 0,
				delivery_rate: 0,
				read_rate: 0,
				active_conversations: 0,
				total_conversations: 0,
				template_messages: 0,
				by_template_type: {},
				by_language: {},
				outbound: { by_type: {} },
				inbound: { by_type: {} },
				totals_by_type: {},
				total_billable: 0
			},
			loading: false,
			startDate: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
			endDate: format(new Date(), 'yyyy-MM-dd'),
			startDateMenu: false,
			endDateMenu: false,
			quickPeriod: null,
			templateTypeLabels: {
				marketing: 'Marketing',
				transactional: 'Transazionale',
				otp: 'OTP',
				unknown: 'Non specificato'
			},
			languageLabels: {
				it: 'Italiano',
				en: 'Inglese',
				es: 'Spagnolo',
				fr: 'Francese',
				de: 'Tedesco',
				unknown: 'Non specificato'
			},
			templateTypeColors: {
				marketing: 'purple',
				transactional: 'blue',
				otp: 'orange',
				unknown: 'grey'
			},
			languageColors: {
				it: 'green',
				en: 'blue',
				es: 'red',
				fr: 'indigo',
				de: 'amber',
				unknown: 'grey'
			}
		}
	},

	computed: {
		failRate() {
			if (!this.statistics.total_sent) return 0
			return Math.round((this.statistics.total_failed / this.statistics.total_sent) * 100)
		},

		templatePercentage() {
			if (!this.statistics.total_delivered) return 0
			return Math.round((this.statistics.template_messages / this.statistics.total_delivered) * 100)
		},

		hasTemplateTypeData() {
			return this.statistics.by_template_type && Object.keys(this.statistics.by_template_type).length > 0
		},

		hasLanguageData() {
			return this.statistics.by_language && Object.keys(this.statistics.by_language).length > 0
		}
	},

	watch: {
		startDate() {
			this.loadStatistics()
		},
		endDate() {
			this.loadStatistics()
		}
	},

	mounted() {
		this.loadStatistics()
	},

	methods: {
		async loadStatistics() {
			try {
				this.loading = true
				const response = await Vue.axios.get('/whatsapp-statistics', {
					params: {
						start_date: this.startDate,
						end_date: this.endDate
					}
				})
				this.statistics = response.data.stats || {}
				this.$store.commit('endProgress')
			} catch (error) {
				console.error('Error loading statistics:', error)
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: 'Errore nel caricamento delle statistiche',
					value: true,
					color: 'error'
				})
				this.$store.commit('endProgress')
			} finally {
				this.loading = false
			}
		},

		setQuickPeriod(period) {
			const now = new Date()
			switch (period) {
				case 'today':
					this.startDate = format(startOfDay(now), 'yyyy-MM-dd')
					this.endDate = format(endOfDay(now), 'yyyy-MM-dd')
					break
				case 'week':
					this.startDate = format(startOfWeek(now, { weekStartsOn: 1 }), 'yyyy-MM-dd')
					this.endDate = format(endOfWeek(now, { weekStartsOn: 1 }), 'yyyy-MM-dd')
					break
				case 'month':
					this.startDate = format(startOfMonth(now), 'yyyy-MM-dd')
					this.endDate = format(endOfMonth(now), 'yyyy-MM-dd')
					break
				case 'year':
					this.startDate = format(startOfYear(now), 'yyyy-MM-dd')
					this.endDate = format(endOfYear(now), 'yyyy-MM-dd')
					break
			}
		},

		getRateColor(rate) {
			if (rate >= 90) return 'success'
			if (rate >= 70) return 'warning'
			if (rate >= 50) return 'orange'
			return 'error'
		},

		getFailRateColor(rate) {
			if (rate <= 5) return 'success'
			if (rate <= 15) return 'warning'
			return 'error'
		},

		setClass(i) {
			if (this.$vuetify.breakpoint.xl || this.$vuetify.breakpoint.lg) {
				if (i == 0) return 'pa-0 pl-0 pr-2'
				if (i == 3) return 'pa-0 pl-2'
				return 'pa-0 pr-2 pl-2'
			}
			if (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md) {
				if (i == 0) return 'pa-0 pl-0 pr-2'
				if (i == 2) return 'pa-0 pl-0 pr-2 pt-4'
				if (i == 3) return 'pa-0 pl-2 pr-0 pt-4'
				return 'pa-0 pl-2 pr-0'
			}
			if (this.$vuetify.breakpoint.xs) {
				if (i == 0) return 'pa-0 pl-0 pr-0'
				return 'pa-0 pl-0 pr-0 pt-4'
			}
		},

		getByType(direction, type) {
			if (!this.statistics[direction] || !this.statistics[direction].by_type) {
				return 0
			}
			return this.statistics[direction].by_type[type] || 0
		},

		getTotalByType(type) {
			if (!this.statistics.totals_by_type) {
				return 0
			}
			return this.statistics.totals_by_type[type] || 0
		},

		getOutboundTotal() {
			if (!this.statistics.outbound || !this.statistics.outbound.by_type) {
				return 0
			}
			const byType = this.statistics.outbound.by_type
			return (byType.marketing || 0) + (byType.transactional || 0) + (byType.otp || 0) + (byType.free_message || 0)
		},

		getInboundTotal() {
			if (!this.statistics.inbound || !this.statistics.inbound.by_type) {
				return 0
			}
			const byType = this.statistics.inbound.by_type
			return (byType.marketing || 0) + (byType.transactional || 0) + (byType.otp || 0) + (byType.free_message || 0)
		}
	}
}
</script>

<style scoped>
.text-h2 {
	font-size: 2.5rem !important;
}
</style>
